import { readMeta } from '../lib/page';

declare const window: any;

export const oneTrustEnabled = () => {
  return readMeta('one_trust_sittercity_web');
};

export const necessaryCookiesEnabled = () => {
  if (!oneTrustEnabled()) {
    return true;
  }
  return window.OnetrustActiveGroups?.includes('C0001');
};

export const performanceCookiesEnabled = () => {
  if (!oneTrustEnabled()) {
    return true;
  }
  return window.OnetrustActiveGroups?.includes('C0002');
};

export const functionalCookiesEnabled = () => {
  if (!oneTrustEnabled()) {
    return true;
  }
  return window.OnetrustActiveGroups?.includes('C0003');
};

export const trackingCookiesEnabled = () => {
  if (!oneTrustEnabled()) {
    return true;
  }
  return window.OnetrustActiveGroups?.includes('C0004');
};
